import { useEffect } from "react";

import { useAppContext } from "@lib/contexts/AppContext";

import Checkout from "./checkout";
import { getPaymentFirstExperiment } from "./paymentFirst";

// Variant entry for the PaymentFirstCheckout A/B test (U1 / OMG-1916).
//
// Mounted only on PAYMENT_FIRST_CHECKOUT_PATH, which Convert redirects bucketed
// users to — the route's presence IS the variant signal. On mount we dispatch
// setExperiment so useAnalytics tags funnel + purchase events with the variant's
// experiment_id / variant_id (the only setExperiment caller in the app).
// Reading the signal here (route mount) rather than at app mount is the decided
// fix for the async window-flag timing race.
//
// Session recording (Clarity) loads globally from index.html on both arms —
// no route-level init here (OMG-1921 decision 2026-07-07).
export const CheckoutPaymentFirst = () => {
  const { setExperiment } = useAppContext();

  useEffect(() => {
    setExperiment(getPaymentFirstExperiment(import.meta.env.VITE_ENV));
    // Fire exactly once on variant-route mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Checkout paymentFirst />;
};

export default CheckoutPaymentFirst;
